// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChartModules_wrapper__lNZoD"};